export class Broadband {
    rate_package_id: string;
    arvato_code: string;
    gescal_code: string;
    latitude = '';
    longitude = '';
    province: string;
    city: string;
    post_code: string;
    street_number: string;
    street_name: string;
    street_type: string;
    staircase_number: string;
    floor_number: string;
    apartment_number: string;
    sponsor: string;
}
